<template>
  <base-input
    :placeholder="placeholder"
    :addon-left-icon="leftIcon"
    :value="value"
    @input="updateValue"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    v-bind="$attrs"
    id="mapPlaces"
  >
  </base-input>
</template>
<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    leftIcon: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      description: "Input value"
    }
  },
  async mounted() {
    const Places = await this.loadMapsLibrary('places');

    const input = document.getElementById("mapPlaces");

    const options = {
      componentRestrictions: { country: "ar" },
      types: ['locality'],
      fields: ['geometry', 'formatted_address']
    }

    const autocomplete = new Places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace()
      this.$emit('placeChanged', autocomplete.getPlace());
      this.$emit('input', place.formatted_address);
    });
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
}
</script>
<style>
</style>